import React from "react";
import { FiInfo } from "react-icons/fi";
import { useTranslation } from "react-i18next";

/** Marks a Välj whose booking brings beds. Decorative: the button carries the description. */
export const BedsIncludedIcon: React.FC<{ className?: string }> = ({
  className = "h-4 w-4",
}) => (
  <FiInfo
    className={`${className} shrink-0`}
    aria-hidden
    data-testid="beds-included-icon"
  />
);

/** What a screen reader hears with the button; the icon itself is hidden from it. */
export const BedsIncludedDescription: React.FC<{ id: string }> = ({ id }) => {
  const { t } = useTranslation();
  return (
    <span id={id} className="sr-only">
      {t("ad_beds.included_description")}
    </span>
  );
};
